import { ALLOCATION_PLANS_THEME } from '../common/riskProfileHeaderTheme'
import BottomSheetContent from '../../../../../../../components/BottomSheetComponents/BottomSheetContent'
import RenderHTML from '../../../../../../../components/ui-components/RenderHTML'

const PLANS_INFO_ICON_STROKE = ALLOCATION_PLANS_THEME.primary

const ALLOCATION_360_PORTFOLIO_OPTIMISATION_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M9.75 16.499L12 18.749L9.75 20.999" stroke="${PLANS_INFO_ICON_STROKE}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 18.7493C6.61522 18.7493 2.25 17.4056 2.25 15.7482C2.25 14.0907 6.61522 12.7471 12 12.7471C17.3848 12.7471 21.75 14.0907 21.75 15.7482C21.75 17.0835 18.9169 18.2151 15 18.6045" stroke="${PLANS_INFO_ICON_STROKE}" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M2.25 7.99902C2.45591 8.58162 3.01153 8.99902 3.66465 8.99902H4.66465C5.49307 8.99902 6.16464 8.32744 6.16464 7.49902V7.24902C6.16464 6.4206 5.49307 5.74902 4.66464 5.74902H4.16466H4.53964C5.29903 5.74902 5.91465 5.1334 5.91465 4.37401C5.91465 3.61462 5.29903 2.99902 4.53964 2.99902H3.78964C3.16026 2.99904 2.62965 3.4219 2.46642 3.99903" stroke="${PLANS_INFO_ICON_STROKE}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10 7.49902V7.24902C10 6.4206 10.6716 5.74902 11.5 5.74902H12.5C13.3284 5.74902 14 6.42058 14 7.24902V7.49902C14 8.32744 13.3284 8.99901 12.5 8.99901L11.5 8.99902C10.6716 8.99902 10 8.32746 10 7.49902ZM10 7.49902L10 4.49902C10 3.67059 10.6716 2.99902 11.5 2.99902H12.5C13.1531 2.99902 13.7087 3.41643 13.9146 3.99901" stroke="${PLANS_INFO_ICON_STROKE}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M17.75 7.49902V4.49902C17.75 3.6706 18.4217 2.99902 19.25 2.99902H20.2501C21.0785 2.99902 21.7501 3.6706 21.7501 4.49902V7.49902C21.7501 8.32744 21.0785 8.99902 20.2501 8.99902H19.25C18.4217 8.99902 17.75 8.32744 17.75 7.49902Z" stroke="${PLANS_INFO_ICON_STROKE}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const ALLOCATION_EXPERT_BUILT_PERSONALISED_PLAN_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M7.5 7.50098C8.94975 7.50098 10.125 6.32573 10.125 4.87598C10.125 3.42623 8.94975 2.25098 7.5 2.25098C6.05025 2.25098 4.875 3.42623 4.875 4.87598C4.875 6.32573 6.05025 7.50098 7.5 7.50098Z" stroke="${PLANS_INFO_ICON_STROKE}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M21.7483 14.2512L14.6833 21.3163L11.4883 21.7513L11.9383 18.5563L18.9883 11.4912L21.7483 14.2512Z" stroke="${PLANS_INFO_ICON_STROKE}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.75 13.0034V12.751C12.75 9.85148 10.3995 7.50098 7.5 7.50098C4.6005 7.50098 2.25 9.85148 2.25 12.751V15.376H4.5L5.25 21.751H8.15051" stroke="${PLANS_INFO_ICON_STROKE}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const ALLOCATION_BUILT_FOR_THE_LONG_TERM_JOURNEY_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M7.375 11.75V14.75" stroke="${PLANS_INFO_ICON_STROKE}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.875 20.75H20.875" stroke="${PLANS_INFO_ICON_STROKE}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.875 17H20.875" stroke="${PLANS_INFO_ICON_STROKE}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10.1589 5.63236C9.98876 4.01324 8.58061 2.75 6.86866 2.75C5.04198 2.75 3.56116 4.18823 3.56116 5.96239C3.56116 6.56971 3.73468 7.13765 4.03618 7.62201C3.34329 7.99931 2.875 8.71949 2.875 9.5459C2.875 10.7632 3.89101 11.75 5.14434 11.75C6.39454 11.75 7.20393 11.75 8.51016 11.75C10.3685 11.75 11.875 10.2868 11.875 8.4819C11.875 7.25879 11.1832 6.19262 10.1589 5.63236Z" stroke="${PLANS_INFO_ICON_STROKE}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.125 2.75C15.625 2.75 16.375 4.25 16.375 4.25C16.375 4.25 17.125 2.75 18.625 2.75" stroke="${PLANS_INFO_ICON_STROKE}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M16.375 7.25C17.875 7.25 18.625 8.75 18.625 8.75C18.625 8.75 19.375 7.25 20.875 7.25" stroke="${PLANS_INFO_ICON_STROKE}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

type AllocationPlanInfoBottomSheetProps = {
  onDismiss: () => void
}

export function AllocationPlanInfoBottomSheet({ onDismiss }: AllocationPlanInfoBottomSheetProps) {
  return (
    <BottomSheetContent
      heading="Allocation Plan"
      onDismiss={onDismiss}
      bottomSheetHeadClassName="!pt-6"
      bottomSheetHeadingClassName="!text-[22px] !text-[#232323] !leading-[130%] !font-[500] !mb-0"
      bottomSheetBodyClassName="!pt-2 !pb-6"
    >
      <div className="text-[14px] font-[400] leading-[150%] text-[#6A6E6E]">
        <p>
          This plan optimises your portfolio&apos;s allocation, performance, diversification, overlaps and more,
          in a tax-efficient manner. Our experts review how your portfolio is currently allocated and create a
          step-by-step plan to reach your ideal allocation.
        </p>
        <div className="flex flex-col gap-6 pt-6">
          <AllocationPlanInfoFeatureRow
            iconHtml={ALLOCATION_360_PORTFOLIO_OPTIMISATION_ICON}
            highlight="360° portfolio optimisation"
            detail="across allocation, returns, risk and more"
          />
          <AllocationPlanInfoFeatureRow
            iconHtml={ALLOCATION_EXPERT_BUILT_PERSONALISED_PLAN_ICON}
            highlight="Expert-built personalised plan"
            detail="for your life stage and risk appetite"
          />
          <AllocationPlanInfoFeatureRow
            iconHtml={ALLOCATION_BUILT_FOR_THE_LONG_TERM_JOURNEY_ICON}
            highlight="Built for the long-term journey"
            detail="to adapt as your needs evolve"
          />
        </div>
      </div>
    </BottomSheetContent>
  )
}

type AllocationPlanInfoFeatureRowProps = {
  iconHtml: string
  highlight: string
  detail: string
}

export function AllocationPlanInfoFeatureRow({
  iconHtml,
  highlight,
  detail
}: AllocationPlanInfoFeatureRowProps) {
  return (
    <div className="flex items-start gap-4">
      <RenderHTML innerHTMLText={iconHtml} className="mt-[5px] size-6 shrink-0" />
      <p className="text-[14px] leading-[150%]">
        <span className="font-[500] text-[#232323]">{highlight}</span>{' '}
        <span className="text-[#6A6E6E]">{detail}</span>
      </p>
    </div>
  )
}
